import { Box } from '@material-ui/core'
import { BackendUser } from 'common/types'
import { Modal } from 'components/core/modal'
import { FunctionComponent } from 'react'
import CopyInviteUrl from './CopyInviteUrl'

interface InviteFriendsByEmailModalProps {
  show: boolean
  onClose: Function
  inviteUsersByEmail: Function
  backendUser: BackendUser
  notify: Function
  partnerId: string
}

export const InviteFriendsByEmailModal: FunctionComponent<InviteFriendsByEmailModalProps> = ({
  show,
  onClose,
  backendUser,
  notify,
  partnerId
}) => {
  return (
    <Modal showCancel show={show} onClose={onClose} noBorder title="">
      <Box display="flex" justifyContent="center">
        <img src="/pages/invitePeeps/invitePeeps.png" alt="" />
      </Box>
      <CopyInviteUrl backendUser={backendUser} notify={notify} partnerId={partnerId} />
    </Modal>
  )
}
